export default "__VITE_ASSET__CmOO0rmg__"